import React from 'react';

import { logUiError } from '~/src/dash/apiV2/logUiError';
import { getVersion } from '~/src/dash/resellers/utils/importResellerConfig';
import { AppErrorView } from '~/src/dash/views/app-error-view';

export interface ErrorObject {
  message?: string;
  name?: string;
  stack?: string;
  request?: string;
  version: string;
}

export class ErrorBoundary extends React.Component<
  { children: any },
  { errorObject: ErrorObject }
> {
  constructor(props: any) {
    super(props);
    this.state = { errorObject: {} as ErrorObject };
  }

  componentDidCatch(error: any) {
    const errorObject = {
      message: error.message,
      name: error.name,
      stack: error.stack,
      request: location.href,
      version: getVersion() || 'N/A',
    };
    this.setState({ errorObject });
  }

  render() {
    const { errorObject } = this.state;
    if (Object.keys(errorObject).length > 0) {
      logUiError(errorObject);
      return <AppErrorView hasUiError errorObject={errorObject} />;
    } else {
      return <>{this.props.children}</>;
    }
  }
}
